var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('router-link',{attrs:{"to":{
    name: 'route-manager',
    params: {
      app: _vm.audit.app_id,
      environment: _vm.audit.environment_id,
      route: _vm.finding.findable.id
    }
  }}},[_c('route-uri',{attrs:{"uri":_vm.finding.findable.uri}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }